"use client";

import { useState, useEffect } from "react";

export function useReturningUserCheck() {
  const [shouldShowRedirect, setShouldShowRedirect] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkReturningUser = () => {
      // Check for session cookie and other indicators client-side
      const hasSession = document.cookie.includes('session=');
      const hasConsent = document.cookie.includes('cookie-consent=');
      const hasFirstVisit = document.cookie.includes('first-visit=');
      
      // Only show redirect if user has session, has given consent, and is not first visit
      const isReturningUser = hasSession && hasConsent && hasFirstVisit;
      
      setShouldShowRedirect(isReturningUser);
      setIsChecking(false);
    };

    // Small delay to avoid hydration issues
    const timer = setTimeout(checkReturningUser, 100);
    
    return () => clearTimeout(timer);
  }, []);

  const cancelRedirect = () => {
    setShouldShowRedirect(false);
  };

  return {
    shouldShowRedirect,
    isChecking,
    cancelRedirect,
  };
}
